/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { IconChevronLeft, IconX } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import {
  useFetchOrderDetailsData,
  useFetchOrderDetailsStatusHistoryData,
  useFetchOrdersData,
  useOrderDeleteMutation,
  useOrderSyncMutation,
  useOrderUpdateMutation,
} from "../../apis/orderApis";
import formatDate, { formatTime } from "../../utilities/helper";
import EditOrderModal from "./_components/EditOrderModal";
import { OrderFormData } from "../../types/types";
import { useForm } from "react-hook-form";
import useDebounce from "../../utilities/useDebounce";
import toast from "react-hot-toast";
import ReverseOrderModal from "./_components/ReverseOrderModal";
import AddOrdersModal from "./_components/AddOrdersModals";
import SmsModal from "./_components/SmsModal";
import DeleteModal from "./_components/DeleteModal";
import MessageModal from "../../components/MessageModal";
import LabelPrintModal from "./_components/LabelPrintModal";
import { useSelector } from "react-redux";

export default function ViewOrderDetails() {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isReverseOrderWiseOpen, setIsReverseOrderWiseOpen] = useState(false);
  const [isRevertOrder, setIsRevertOrder] = useState(false);
  const [isSmsOpen, setIsSmsOpen] = useState(false);
  const [isForword3PlOpen, setIsForword3PlOpen] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [order, setOrder] = useState<any>();
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const openForword3PlModal = (order: any) => {
    setOrder(order);
    setIsForword3PlOpen(true);
  };
  const closeForword3PlModal = () => setIsForword3PlOpen(false);
  const openSmsModal = () => setIsSmsOpen(true);
  const closeSmsModal = () => setIsSmsOpen(false);
  const openEditModal = (data: any) => {
    setOrder(data);
    setIsEditOpen(true);
  };
  const [orderItemId, setOrderItemId] = useState<any>(null);
  const closeEditModal = () => setIsEditOpen(false);

  const { mutate: deleteMutate, isPending: isDeletePending } =
    useOrderDeleteMutation(order?.id ?? "");
  const { mutate: updateMutate, isPending: isUpdatePending } =
    useOrderUpdateMutation(order?.id ?? "");

  const [activeTab, setActiveTab] = useState("All");

  const {
    data: orders,
    isPending: listPending,
    refetch,
  } = useFetchOrdersData(pageNo);

  const openDeleteModal = (data: any) => {
    setOrder(data);
    setIsDeleteOpen(true);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit, activeTab]);

  const {
    register,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    control,
    handleSubmit,
  } = useForm<OrderFormData>();

  const {
    register: forwardRegister,
    setValue: setForwardValue,
    clearErrors: forwardClearErrors,
    formState: { errors: forwardErrors },
    watch: forwardWatch,
    handleSubmit: handleForwardSubmit,
  } = useForm<any>();

  const {
    register: deleteRegister,
    setValue: deleteSetValue,
    clearErrors: deleteClearErrors,
    formState: { errors: deleteErrors },
    watch: deleteWatch,
    reset: deleteReset,
    handleSubmit: deleteHandleSubmit,
  } = useForm<any>();
  const closeDeleteModal = () => setIsDeleteOpen(false);
  const openReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(true);
  const closeReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(false);
  const closeRevertOrder = () => setIsRevertOrder(false);

  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navigate = useNavigate();

  const deleteOrder = (data: any) => {
    deleteMutate(data, {
      onSuccess: (data) => {
        deleteReset();
        setIsDeleteOpen(false);
        refetch();
        toast.success("Order deleted successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to delete order");
      },
    });
  };

  const handleUpdateOrder = (data: any) => {
    updateMutate(data, {
      onSuccess: (data) => {
        setIsEditOpen(false);
        refetch();
        toast.success("Order updated successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to update order");
      },
    });
  };

  const handleLabelPrint = (data: any) => {
    setOrder(data);
    setShowLabelModal(true);
  };

  const getStatusButtonClass = (status: string) => {
    const normalized = status?.toLowerCase();

    switch (normalized) {
      case "draft": // neutral / gray
        return "bg-gray-100 border-gray-400 text-gray-700";
      case "new_order": // info → blue
        return "bg-blue-100 border-blue-500 text-blue-700";
      case "processing": // progress → indigo
        return "bg-indigo-100 border-indigo-500 text-indigo-700";
      case "ready_for_pickup": // waiting → amber/yellow
        return "bg-amber-100 border-amber-500 text-amber-700";
      case "dispatched": // moving → teal/greenish
        return "bg-teal-100 border-teal-500 text-teal-700";
      case "in_transit": // traveling → sky
        return "bg-sky-100 border-sky-500 text-sky-700";
      case "out_for_delivery": // active → orange
        return "bg-orange-100 border-orange-500 text-orange-700";
      case "delivered": // success → green
        return "bg-green-100 border-green-600 text-green-700";
      case "undelivered": // warning → amber
        return "bg-amber-100 border-amber-600 text-amber-700";
      case "returned": // secondary issue → purple/pink
        return "bg-purple-100 border-purple-500 text-purple-700";
      case "cancelled": // error → red
        return "bg-red-100 border-red-600 text-red-700";
      case "failed": // danger → rose
        return "bg-rose-100 border-rose-600 text-rose-700";
      case "lost": // dark/neutral → zinc
        return "bg-zinc-100 border-zinc-500 text-zinc-700";
      case "deleted": // destructive → dark red
        return "bg-red-100 border-red-700 text-red-800";
      default: // fallback neutral
        return "bg-gray-100 border-gray-400 text-gray-700";
    }
  };

  const getStatusTextClass = (status: string) => {
    const normalized = status?.toLowerCase();

    switch (normalized) {
      case "draft": // neutral / gray
        return "text-gray-700";
      case "new_order": // info → blue
        return "text-blue-700";
      case "processing": // progress → indigo
        return "text-indigo-700";
      case "ready_for_pickup": // waiting → amber/yellow
        return "text-amber-700";
      case "dispatched": // moving → teal/greenish
        return "text-teal-700";
      case "in_transit": // traveling → sky
        return "text-sky-700";
      case "out_for_delivery": // active → orange
        return "text-orange-700";
      case "delivered": // success → green
        return "text-green-700";
      case "undelivered": // warning → amber
        return "text-amber-700";
      case "returned": // secondary issue → purple
        return "text-purple-700";
      case "cancelled": // error → red
        return "text-red-700";
      case "failed": // danger → rose
        return "text-rose-700";
      case "lost": // dark/neutral → zinc
        return "text-zinc-700";
      case "deleted": // destructive → dark red
        return "text-red-800";
      default: // fallback neutral
        return "text-gray-700";
    }
  };

  const Section = ({
    title,
    children,
    className,
  }: {
    title?: string;
    className?: string;
    children: React.ReactNode;
  }) => (
    <div
      className={`p-4 bg-[#F7F6F2] rounded-3xl  overflow-y-auto ${className}`}
    >
      {title === "TimeLine" ? null : (
        <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
          {title}
        </h3>
      )}

      <div className="grid grid-cols-1 ">{children}</div>
    </div>
  );

  // Tooltip.tsx

  interface TooltipProps {
    label: string;
    children: React.ReactNode;
  }

  const Tooltip: React.FC<TooltipProps> = ({ label, children }) => {
    return (
      <div className="relative group inline-block">
        {children}
        <div className="absolute left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block">
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 rotate-45 bg-black"></div>
          <div className="whitespace-nowrap rounded-md bg-black px-2 py-1 text-xs text-white shadow-lg">
            {label}
          </div>
        </div>
      </div>
    );
  };

  const { data, refetch: fetchOrderDetails } = useFetchOrderDetailsData(
    id ?? "",
  );
  const { data: statusHistories } = useFetchOrderDetailsStatusHistoryData(
    id ?? "",
  );

  const TwoCol = ({ label, value }: { label: string; value: string }) => (
    <div className="text-sm text-[#1E293B] flex justify-between  gap-1 border-b py-3 last:border-0 px-4">
      <p className=" text-[#212121] capitalize flex-shrink-0">{label}:</p>
      <p className="font-medium text-end"> {value}</p>
    </div>
  );

  const formatStatus = (status: string) => {
    return status
      ?.toLowerCase()
      ?.split("_")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");
  };

  const [expend, setExpend] = useState(false);

  const hasVariantData = data?.olineItems?.some(
    (item: any) => item?.optionName && item?.optionValue,
  );

  const shouldShowClientId = data?.subStatus !== "reverseOrder";

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <h1 className="text-xl font-medium text-[#212121]  ">
              AWB No: {data?.awbNumber}
            </h1>
          </div>

          <div className="flex items-center gap-2">
            <div
              className={`flex items-center justify-end space-x-2 transition-all duration-150   w-0 ${
                expend ? "w-80" : "overflow-hidden "
              }`}
            >
              {data?.status === "DELIVERED" ? (
                <>
                  <Tooltip label="Reverse Order">
                    <button
                      onClick={() => {
                        setOrderItemId(data?.id);
                        openReverseOrderWiseModal();
                      }}
                      className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                    >
                      <img
                        src="/img/dashboard-icons/reverse-item.svg"
                        className="size-6"
                      />
                    </button>
                  </Tooltip>
                </>
              ) : (
                <>
                  {data?.status !== "DELETED" && (
                    <>
                      <Tooltip label="Edit Order">
                        <button
                          onClick={() => openEditModal(data)}
                          className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                        >
                          <img
                            src="/img/dashboard-icons/edit.svg"
                            className="size-6"
                          />
                        </button>
                      </Tooltip>
                      <Tooltip label="Print Order">
                        <button
                          onClick={() => handleLabelPrint(data)}
                          className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                        >
                          <img
                            src="/img/dashboard-icons/print.svg"
                            className="size-6"
                          />
                        </button>
                      </Tooltip>

                      <Tooltip label="Delete Order">
                        <button
                          onClick={() => openDeleteModal(data)}
                          className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                        >
                          <img
                            src="/img/dashboard-icons/trash.svg"
                            className="size-6"
                          />
                        </button>
                      </Tooltip>
                    </>
                  )}
                </>
              )}
            </div>
            <button
              onClick={() => setExpend(!expend)}
              className="bg-[#FBD037] border border-[#FBD037] text-sm w-12 h-12 text-center  rounded-full flex items-center justify-center cursor-pointer"
            >
              {expend ? (
                <IconX size={20} />
              ) : (
                <img src="/img/dashboard-icons/menu.svg" className="w-5 h-5" />
              )}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-6 gap-4">
          <div className="grid grid-cols-2 gap-4 col-span-4 p-4 bg-[#F7F6F2] rounded-3xl border border-[#EFEFEF] ">
            <div className="bg-[#FCFDF8] border rounded-2xl overflow-auto ">
              <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                Sender Info
              </h3>
              <TwoCol label="Outlet Code" value={data?.clientId || ""} />
              <TwoCol label="Sender Name" value={data?.senderName} />
              <TwoCol label="Mobile" value={data?.senderMobile || ""} />
              <TwoCol label="Email" value={data?.senderEmail || ""} />
              <TwoCol label="Store Link" value={data?.storeLink || ""} />
              <TwoCol label="Iqama No." value={data?.senderIqamaNo || ""} />
              <TwoCol label="Country" value={data?.senderCountryName || ""} />
              <TwoCol label="City" value={data?.senderCityName || ""} />
              <TwoCol label="Area" value={data?.senderDistrictName || ""} />
              <TwoCol label="Zip Code" value={data?.senderZipCode || ""} />
              {data?.senderLatitude && (
                <TwoCol label="Latitude" value={data?.senderLatitude || ""} />
              )}
              {data?.senderLongitude && (
                <TwoCol
                  label="Longitude"
                  value={data?.senderLongitude || ""}
                />
              )}
              <TwoCol
                label="National Address"
                value={data?.senderNationalAddress || ""}
              />
              <TwoCol
                label="Address"
                value={data?.senderAddress || ""?.replace(/<[^>]*>/g, "")}
              />
            </div>
            <div className="bg-[#FCFDF8] border rounded-2xl overflow-auto">
              <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                Receiver Info
              </h3>

              <TwoCol label="Name" value={data?.receiverName || ""} />
              <TwoCol label="Mobile" value={data?.receiverMobile || ""} />
              <TwoCol label="Email" value={data?.receiverEmail || ""} />
              <TwoCol
                label="Country"
                value={data?.receiverCountryName || data?.receiverCountryData}
              />
              <TwoCol
                label="City"
                value={data?.receiverCityName || data?.receiverCityData}
              />
              <TwoCol
                label="Area"
                value={data?.receiverDistrictName || data?.receiverDistrictData}
              />
              {data?.receiverStreet && (
                <TwoCol label="Street" value={data?.receiverStreet} />
              )}
              {data?.receiverBuildingName && (
                <TwoCol
                  label="Building Name / No"
                  value={data?.receiverBuildingName}
                />
              )}
              <TwoCol label="Zip Code" value={data?.receiverZipCode} />
              {data?.receiverLatitude && (
                <TwoCol label="Latitude" value={data?.receiverLatitude} />
              )}
              {data?.receiverLongitude && (
                <TwoCol label="Longitude" value={data?.receiverLongitude} />
              )}
              <TwoCol
                label="National Address"
                value={data?.receiverNationalAddress}
              />
              <TwoCol
                label="Address"
                value={data?.receiverAddress?.replace(/<[^>]*>/g, "")}
              />
            </div>
            <div
              title=""
              className="bg-[#FCFDF8] border rounded-2xl overflow-auto col-span-2"
            >
              <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                Order Summary
              </h3>
              <div className="grid gap-12 grid-cols-2">
                <div className=" ">
                  <TwoCol
                    label="Reference Number"
                    value={data?.referenceNumber}
                  />
                  <TwoCol
                    label="Shipper Reference"
                    value={data?.shipmentReference}
                  />
                  <TwoCol
                    label="Forwarded AWB No"
                    value={data?.shippingAwbNumber}
                  />
                  <TwoCol
                    label="Forwarded Company"
                    value={data?.shippingCompany}
                  />
                  <TwoCol label="Warehouse" value={data?.warehouseName} />
                  <TwoCol
                    label="Entry Date"
                    value={formatDate(data?.createdAt)}
                  />
                  <TwoCol label="No of Pieces" value={data?.noOfPieces} />
                  <TwoCol
                    label="Payment Mode & Amount"
                    value={`${data?.paymentType} - ${data?.codAmount || "0"}`}
                  />
                  <TwoCol
                    label="Close Date"
                    value={data?.closedDate ? formatDate(data.closedDate) : ""}
                  />

                  <TwoCol
                    label="Attempt"
                    value={
                      data?.totalDeliveryAttempt
                        ? String(data.totalDeliveryAttempt)
                        : "0"
                    }
                  />
                </div>
                <div className=" ">
                  {data?.deliveryAttemptDates &&
                    Array?.isArray(data?.deliveryAttemptDates) &&
                    data?.deliveryAttemptDates?.map(
                      (date: any, index: number) => (
                        <TwoCol
                          label={`FD${index + +1}`}
                          value={formatDate(date)}
                        />
                      ),
                    )}

                  <TwoCol label="Weight" value={`${data?.totalWeight} KG`} />
                  <TwoCol label="Shelf No" value={data?.shelfNo} />
                  <TwoCol label="Shelf Location" value={data?.shelfLocation} />
                  <TwoCol
                    label="Scheduled Info"
                    value={`${data?.Scheduled || ""} - ${
                      data?.scheduleChannel || ""
                    }`}
                  />

                  <TwoCol label="On Hold" value={data?.onHold} />
                  <TwoCol label="Service Type" value={data?.serviceType} />
                  <TwoCol label="Route Code" value={data?.routeCode} />
                  <TwoCol label="Product Type" value={data?.shipmentType} />
                </div>
              </div>
            </div>

            {data?.olineItems && data?.olineItems?.length > 0 && (
              <Section
                title="Item Summary"
                className="bg-[#FCFDF8] rounded-2xl overflow-auto col-span-2 border border-[#e8e8e8] "
              >
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-[#D8D8D8] border-dashed">
                      <th className="text-center p-2 text-sm font-medium text-[#212121]/70">
                        #
                      </th>
                      {data?.olineItems?.some((item: any) => item.sku) && (
                        <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                          SKU
                        </th>
                      )}
                      <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                        Item Name
                      </th>
                      {data?.olineItems?.some((item: any) => item.weight) && (
                        <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                          Weight
                        </th>
                      )}
                      <th className="text-center p-2 text-sm font-medium text-[#212121]/70">
                        Quantity
                      </th>
                      <th className="text-center p-2 text-sm font-medium text-[#212121]/70">
                        Price
                      </th>
                      {hasVariantData && (
                        <>
                          <th className="text-center p-2 text-sm font-medium text-[#212121]/70">
                            Variant Value
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {data?.olineItems?.map((item: any, i: number) => (
                      <tr
                        key={i}
                        className="hover:bg-[#FBD037]/20 transition cursor-pointer"
                      >
                        <td className="p-3 text-[#212121] text-center text-sm">
                          {i + 1}
                        </td>
                        {data?.olineItems?.some((item: any) => item.sku) && (
                          <td className="p-3 text-sm text-[#212121]">
                            {item.sku}
                          </td>
                        )}
                        <td className="p-3 text-sm text-[#212121]">
                          <div className="flex items-center space-x-2">
                            <div>
                              <p>{item.itemName}</p>
                            </div>
                          </div>
                        </td>
                        {data?.olineItems?.some((item: any) => item.weight) && (
                          <td className="p-3 text-sm text-[#212121] text-center">
                            {item.weight} {item.weightUnit}
                          </td>
                        )}
                        <td className="p-3 text-sm text-[#212121] text-center">
                          {item.quantity}
                        </td>
                        <td className="p-3 text-sm text-[#212121] text-center">
                          <div className="flex justify-center items-center gap-1">
                            <img
                              src="/img/riyal-icon.svg"
                              className="w-3 h-3"
                              alt="SAR"
                            />
                            <p>{item.price}</p>
                          </div>
                        </td>

                        {hasVariantData && (
                          <>
                            <td className="p-3 text-sm text-[#212121] text-center">
                              {item.optionValue || ""}
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Section>
            )}
          </div>
          <Section title="TimeLine" className="col-span-2">
            <div className="flex justify-between items-end">
              <h2 className="text-[#212121] font-medium text-lg pb-3">
                TimeLine
              </h2>
              <div className="flex items-center gap-2">
                <div
                  className={`bg-[#FBD037]/20 border text-sm px-4 text-center 
                  py-2 rounded-full flex items-center gap-1 ${getStatusButtonClass(
                    data?.status,
                  )}`}
                >
                  {formatStatus(
                    statusHistories?.slice()?.reverse()?.[0]?.status,
                  )}
                </div>
                <button className="bg-[#FBD037]/20 border border-[#FBD037] text-sm w-10 h-10 text-center  rounded-full flex items-center justify-center cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={18}
                    height={18}
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M8.99972 0C5.51378 0 2.67773 2.83604 2.67773 6.32199C2.67773 10.6777 8.35379 17.5218 8.59543 17.811C8.80574 18.0628 9.19342 18.0632 9.40401 17.811C9.64565 17.5218 15.3217 10.6777 15.3217 6.32199C15.3217 2.83604 12.4857 0 8.99972 0ZM8.99972 16.6322C7.70231 14.9836 3.7314 9.66411 3.7314 6.32199C3.7314 3.41703 6.09477 1.05366 8.99972 1.05366C11.9047 1.05366 14.268 3.41703 14.268 6.32199C14.268 9.66411 10.2972 14.9836 8.99972 16.6322Z"
                      fill="black"
                    />
                    <path
                      d="M12.6876 5.79525H12.1167C11.894 4.47357 10.8483 3.42791 9.52665 3.20524V2.63425C9.52665 2.3433 9.29077 2.10742 8.99981 2.10742C8.70886 2.10742 8.47298 2.3433 8.47298 2.63425V3.20524C7.1513 3.42794 6.10564 4.4736 5.88297 5.79525H5.31199C5.02104 5.79525 4.78516 6.03113 4.78516 6.32208C4.78516 6.61303 5.02104 6.84891 5.31199 6.84891H5.88297C6.10564 8.17059 7.1513 9.21625 8.47298 9.43893V10.0099C8.47298 10.3009 8.70886 10.5367 8.99981 10.5367C9.29077 10.5367 9.52665 10.3009 9.52665 10.0099V9.43893C10.8483 9.21622 11.894 8.17056 12.1167 6.84891H12.6876C12.9786 6.84891 13.2145 6.61303 13.2145 6.32208C13.2145 6.03113 12.9786 5.79525 12.6876 5.79525ZM8.99981 8.42941C7.83783 8.42941 6.89249 7.48406 6.89249 6.32208C6.89249 5.1601 7.83783 4.21475 8.99981 4.21475C10.1618 4.21475 11.1071 5.1601 11.1071 6.32208C11.1071 7.48406 10.1618 8.42941 8.99981 8.42941Z"
                      fill="black"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="relative border-gray-200 mt-4">
              {statusHistories
                ?.slice()
                .reverse()
                .map((step: any, idx: any) => (
                  <div key={idx} className="mt-2">
                    <div className="flex items-start space-x-4">
                      <div className=" h-32 w-10 relative flex items-center justify-center flex-shrink-0">
                        {idx !== statusHistories?.length - 1 && (
                          <div
                            className={`h-28 w-0.5 ${
                              idx !== 0 ? " bg-black" : "bg-gray-300"
                            }`}
                          ></div>
                        )}
                        <span
                          className={`absolute left-[8px] top-0 flex items-center justify-center w-6 h-6 rounded-full ${
                            idx !== 0
                              ? "bg-[#212121]"
                              : "bg-[#F7F6F2] border-2 border-gray-300"
                          }`}
                        >
                          {idx !== 0 ? (
                            <svg
                              className="w-3 h-3 text-white  "
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          ) : (
                            <div className="bg-gray-300 w-2 h-2 rounded-full"></div>
                          )}
                        </span>
                      </div>
                      <div className="space-y-2 w-full">
                        <div>
                          <div className="flex items-center justify-between">
                            <h3
                              className={`font-medium  text-base ${getStatusTextClass(
                                step?.status,
                              )}`}
                            >
                              {step?.subStatus
                                ? `${formatStatus(step?.subStatus)}/`
                                : ""}
                              {formatStatus(step?.status)}
                            </h3>

                            <time className="block  text-xs font-normal leading-none text-gray-600">
                              {formatDate(step.createdAt)},{" "}
                              {formatTime(step.createdAt)}
                            </time>
                          </div>

                          <p className="text-gray-800 text-sm">
                            {step.details}
                          </p>
                          <div className="mt-1">
                            <p className="text-gray-800 text-xs inline">
                              {step.comment
                                ? step.comment
                                    .split(
                                      /((?:city|district)\s+)(.*?)(?=\s+is)/gi,
                                    )
                                    .map((part: any, i: any) => {
                                      if (i % 3 === 2) {
                                        return (
                                          <span
                                            key={i}
                                            className="text-blue-600 font-bold"
                                          >
                                            {part}
                                          </span>
                                        );
                                      }
                                      return part;
                                    })
                                : ""}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 flex-wrap">
                          {step?.assignedUser && (
                            <div className="flex items-center  text-xs border-[0.5px] p-1 rounded">
                              <span>Assigned Driver: </span>
                              <span className="text-gray-600 ml-1">
                                {step.assignedUser}
                              </span>
                            </div>
                          )}
                          <div className="flex items-center  text-xs border-[0.5px] p-1 rounded">
                            <span>{step?.userType}</span>
                            <span className="text-gray-600 ml-1">
                              : {step.userName}
                            </span>
                          </div>

                          {step?.referenceId && (
                            <div className="flex items-center  text-xs border-[0.5px] p-1 rounded">
                              <span>Reference</span>
                              <span className="text-gray-600 ml-1">
                                : {step.referenceId}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </Section>
        </div>
      </div>

      {selectedOption === "NewOrder" && showModal && (
        <AddOrdersModal
          onClose={() => setShowModal(false)}
          fetchData={refetch}
        />
      )}

      {selectedOption === "ReverseOrder" && showReverseModal && (
        <ReverseOrderModal onClose={() => setShowReverseModal(false)} />
      )}
      <EditOrderModal
        open={isEditOpen}
        onClose={closeEditModal}
        order={order}
        register={register}
        errors={errors}
        setValue={setValue}
        watch={watch}
        clearErrors={clearErrors}
        handleSubmit={handleSubmit(handleUpdateOrder)}
        isPending={isUpdatePending}
      />
      <SmsModal open={isSmsOpen} onClose={closeSmsModal} />

      <DeleteModal
        open={isDeleteOpen}
        onClose={closeDeleteModal}
        deleteOrder={deleteHandleSubmit(deleteOrder)}
        isDeletePending={isDeletePending}
        register={deleteRegister}
        clearErrors={deleteClearErrors}
        watch={deleteWatch}
        setValue={deleteSetValue}
        errors={deleteErrors}
      />

      <MessageModal
        open={isReverseOrderWiseOpen}
        onClose={closeReverseOrderWiseModal}
        title="Confirmation Required"
        subtitle="Are you sure you want to reverse this order?"
        img={"/img/inactive.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        size="md"
      />
      <MessageModal
        open={isRevertOrder}
        onClose={closeRevertOrder}
        title="Confirmation Required"
        subtitle="Are you sure you want to revert this order?"
        img={"/img/active.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        size="md"
      />
      <LabelPrintModal
        open={showLabelModal}
        onClose={() => setShowLabelModal(false)}
        order={order}
      />
    </>
  );
}
